import Styles from './ChapterView.scss';

import Template from './ChapterView.hbs';
import ContentLabel from 'views/components/contentLabel/ContentLabel.svelte'
import ProgressBar from 'views/components/progressBar/ProgressBar.svelte'
import SectionItemTemplate from './SectionItemTemplate.hbs'
import ContentLabelModel from 'models/ContentLabelModel'
import ExemptionLabel from 'views/components/exemptionLabel/ExemptionLabel.svelte'

export default class ChapterView extends BaseView {

    initialize() {

        let courseBrandingLogo
        if (this.model.get('course_branding_id')) {
            courseBrandingLogo = Backbone.Collection.course_branding.get(this.model.get('course_branding_id'))?.get('logo_white')
        }

        const contentLabelModel = new ContentLabelModel(null, {layerModel: this.model})

        this.setElement(Template({
            Styles,
            id: this.model.id,
            index: contentLabelModel.get('index'),
            title: contentLabelModel.get('title'),
            name: contentLabelModel.get('name'),
            isNumberless: contentLabelModel.get('isNumberless'),
            background: this.model.get('image'),
            backgroundPos: this.model.get('background_image_position'),
            courseBrandingLogo,
        }))

        this.model.sections.forEach((section) => {
            const sectionItemTemplate = $(SectionItemTemplate({Styles}))

            this.addSvelteChildView(
                sectionItemTemplate.find('.js-content-label'),
                ContentLabel,
                {
                    model: section,
                    link: `/${section.constructor.pluralType}/show/${section.id}`,
                }
            )

            if (ACL.checkRole(ACL.roles.STUDENT)) {
                this.renderProgressbar(section, sectionItemTemplate)
                this.renderExemptionLabel(section, sectionItemTemplate)
                this.listenTo(section, 'change:progress', (model) => {
                    this.renderProgressbar(model, sectionItemTemplate)
                })
                this.listenTo(section, 'change:hasExemption', (model) => {
                    this.renderExemptionLabel(model, sectionItemTemplate)
                })
            }
            this.$('.js-sections').append(sectionItemTemplate)
        })

    }

    renderProgressbar(model, sectionItemTemplate) {
        if (Number.isFinite(model.get('progress'))) {
            this[`progressbar-section-${model.id}`] = this.addSvelteChildView(
                sectionItemTemplate.find('.js-progress-bar'),
                ProgressBar,
                {
                    fragments: {
                        blue: model.get('progress')
                    },
                    showLabel: !ISMOBILE,
                    width: ISMOBILE ? 40 : 50,
                }
            )
        } else {
            this.unregisterAndDestroyChildView(this[`progressbar-section-${model.id}`])
        }
    }

    renderExemptionLabel(model, sectionItemTemplate) {
        if (model.get('hasExemption')) {
            this[`exemptionLabel-section-${model.id}`] = this.addSvelteChildView(
                sectionItemTemplate.find('.js-exemption-label'),
                ExemptionLabel
            )
        } else {
            this.unregisterAndDestroyChildView(this[`exemptionLabel-section-${model.id}`])
        }
    }

}
